import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '@services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  private router = inject(Router);
  private authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const loggedUser = this.authService.loggedUser;
    if (!loggedUser) {
      return this.router.createUrlTree(['/auth/login']);
    }
    return true;

    // if (route.data['auth']) {
    //   let redirectUrl = route.data['redirectUrl'];
    //
    //   let allowedRoles = route.data['auth'];
    //   if (intersection(loggedUser.roles, allowedRoles).length <= 0) {
    //     if (redirectUrl) {
    //       return this.router.createUrlTree([redirectUrl]);
    //     } else {
    //       console.log('here')
    //       return this.router.createUrlTree(['/main/dashboard']);
    //     }
    //   }
    // }
    //
    // return true;
  }

}
